import License from './license'

export default class User {
    constructor(data = []) {
        this.licenses = [];
        this.discountsAvailable = false

        for (var i in data) {
            this[i] = data[i];
        }
        this.licenses = this.initLicenses(this.licenses);
    }

    initLicenses(licenses) {
        let initLicenses = [];

        for (var i = 0; i < licenses.length; i++) {
            initLicenses.push(new License(licenses[i]));

            if (!this.discountsAvailable && licenses[i].enabled && licenses[i].discountsEnabled && licenses[i].discounts.length > 0) {
                this.discountsAvailable = true
            }
        }

        return initLicenses;
    }

    licenseById(id) {
        for (var i = 0; i < this.licenses.length; i++) {
            if (this.licenses[i].id == id) return this.licenses[i];
        }

        return false;
    }

    isPaid() {
        return this.muser.package != 1;
    }
}